var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 text-center"},[_c('h1',{staticClass:"mt-4 mb-4"},[_vm._v("MLRS Receipt")]),_c('hr')])])}]

export { render, staticRenderFns }